// extracted by mini-css-extract-plugin
export default {"header":"CpcrTpM8","headerLogo":"l9q4H410","buttonMenu":"WO7qKbB0","headerLeftSide":"Jkvw7Jox","titleProject":"ky900KPd"};